import React from "react"
import { Redirect } from "react-router"
import { userHasNewBranding, userHasNewDashboard } from "../../providers/auth.service"

// Redirecting while rendering would update the router mid-render, so render a <Redirect> instead
const Landing: React.FC = () => {

    if (userHasNewDashboard()) {
        return <Redirect push to="/dashboard"/>
    }
    else if (userHasNewBranding()) {
        return <Redirect push to="/activity"/>
    }
    else {
        return <Redirect to="/answerSets"/>
    }
}

export default Landing
